import { inject, Injectable } from '@angular/core';
import { MethodsFacade } from '@p2p/payment/domain';

@Injectable({
    providedIn: 'root'
})
export class PaymentApiService {
    private readonly methodsFacade = inject(MethodsFacade);

    readonly paymentMethods$ = this.methodsFacade.methods$;
    readonly paymentMethodsLoaded$ = this.methodsFacade.methodsLoaded$;
    readonly paymentMethodsError$ = this.methodsFacade.methodsError$;

    loadPaymentMethods(): void {
        this.methodsFacade.loadPaymentMethods();
    }
}
